import React from 'react';
import { NavLink, Link } from 'react-router-dom'; // <--- Check this line carefully!
import './Navbar.css';

const Navbar = () => {
    return (
        <nav className="navbar">
            <div className="nav-logo">THE PILLAR</div>
            
            <ul className="nav-links">
                {/* We use NavLink here so we can style the 'active' state */}
                <li>
                    <NavLink to="/" className={({ isActive }) => isActive ? "active-link" : ""}>
                        Home
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/services" className={({ isActive }) => isActive ? "active-link" : ""}>
                        Services
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/about" className={({ isActive }) => isActive ? "active-link" : ""}>
                        About
                    </NavLink>
                </li>
            </ul>

            {/* We keep Link here because the CTA doesn't need an 'active' highlight */}
            <Link to="/contact" className="nav-cta">GET STARTED</Link>
        </nav>
    );
};

export default Navbar;